module.exports = __webpack_public_path__ + "img/hand-holding-usd.d8129ad.svg";